import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { CheckboxEl } from "common/components/checkbox";
import { InputGroupEl } from "common/components/input-group";
import { SpinnerEl } from "common/components/spinner";
import { SvgIconEl } from "common/components/svg-icon";
export function template() {
  const checkboxDisabled = this.state.removePasswordLoading || this.state.setPasswordLoading;
  return /* @__PURE__ */ jsx("div", {
    sel: ".public-dashboard-password-row"
  }, /* @__PURE__ */ jsx(CheckboxEl, {
    attrs: {
      checked: this.attr(`password-protected`) || this.state.editingPassword,
      elref: `passwordRowCheckbox_${this.attr(`public-link-id`)}`,
      disabled: checkboxDisabled
    },
    on: { click: !checkboxDisabled && this.helpers.handleCheckboxClick }
  }, "Require Passcode", this.state.removePasswordLoading && /* @__PURE__ */ jsx(SpinnerEl, null)), /* @__PURE__ */ jsx("div", {
    sel: ".input-area",
    class: {
      "editing-password": this.state.editingPassword
    }
  }, this.state.editingPassword ? /* @__PURE__ */ jsx("div", {
    sel: ".edit-password-wrapper"
  }, /* @__PURE__ */ jsx(InputGroupEl, {
    attrs: {
      elref: `passwordRowInputGroup_${this.attr(`public-link-id`)}`,
      label: `Save`,
      value: this.state.password,
      busy: this.state.setPasswordLoading,
      disabled: this.state.setPasswordLoading,
      required: true,
      min: 8,
      maxlength: 32,
      "value-type": `passcode`,
      "value-type-article": `a`
    },
    on: {
      input: this.helpers.handlePasswordInput,
      submit: this.helpers.handleSaveClick
    },
    sel: ".password-input"
  }), /* @__PURE__ */ jsx("div", {
    sel: ".password-info-wrapper"
  }, /* @__PURE__ */ jsx("span", {
    sel: ".info-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `info` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".info-text-wrapper"
  }, /* @__PURE__ */ jsx("p", null, " Minimum length of 8 characters."), /* @__PURE__ */ jsx("p", null, " Passcodes can not be recovered after they are set.")))) : this.attr(`password-protected`) && /* @__PURE__ */ jsx("span", {
    sel: ".password-protected-wrapper"
  }, "\u2022\u2022\u2022\u2022\u2022\u2022\u2022", /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".edit-btn",
    on: { click: this.helpers.handleEditClick },
    attrs: { elref: `linkPasswordResetButton` }
  }, "Reset"), this.attr(`public-link-embed-link-with-passcode`).length ? /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".edit-btn",
    on: { click: () => this.helpers.copyEmbedLink(this.attr(`public-link-embed-link-with-passcode`)) },
    attrs: { icon: `duplicate`, elref: `embedLinkButton` }
  }, "Embed Link") : null)));
}
